import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "../framework/api"
import { useAuthToken } from "./useAuthToken"

export type AdminNegativeFeedbackItem = {
  Id: number
  CreatedAt: string
  UserUid: string | null
  UserEmail: string | null
  UserProfileName: string | null
  Source: string
  Sentiment: string | null
  Message: string
  Name: string | null
  Email: string | null
  AppVersion: string | null
  Platform: string | null
  DeviceModel: string | null
  ReviewFlowEventId: string | null
  Context: Record<string, unknown> | null
}

export type AdminFeedbackCount = {
  Source?: string
  Sentiment?: string
  Count: number
}

export type AdminReviewFeedbackResponse = {
  TotalCount: number
  TotalPositiveCount: number
  TotalNegativeCount: number
  TotalNeutralCount: number
  SourceCounts: AdminFeedbackCount[]
  SentimentCounts: AdminFeedbackCount[]
  RecentFeedback: AdminNegativeFeedbackItem[]
  NegativeFeedback: AdminNegativeFeedbackItem[]
}

export function useReviewFeedback(limit = 200) {
  const token = useAuthToken()

  return useQuery({
    queryKey: ["reviewFeedback", { limit }],
    queryFn: async () => {
      return await apiFetch<AdminReviewFeedbackResponse>(`/admin/feedback?limit=${limit}`, {
        token,
        method: "GET",
      })
    },
  })
}
